const PGAdapter = require('../../common/pg-adapter')

const PROGRAM_COLUMNS = [
  'id',
  'fsid',
  'name',
  'options',
  'created_at',
  'updated_at'
]

class ProgramPgAdapter extends PGAdapter {
  constructor ({ pgConnection, username, logger }) {
    super(pgConnection, 'avocado.data_program', username, PROGRAM_COLUMNS, 'id', {}, logger)
  }

  // Programs for an explicit set of ids. Callers pass the ids the requesting
  // user is allowed to see — see tools.scopedProgramIds, which the agave
  // controller uses. There is deliberately no "every program" read here that an
  // HTTP route could reach by accident; unscoped reads go through the inherited
  // getList.
  //
  // The id is matched against the `fsid` column, not the table's own numeric
  // primary key — that's what the inherited getOne/getList take.
  async listByIds (ids, { client } = {}) {
    if (!ids || !ids.length) return []
    const { results } = await this.getList({
      filter: { fsid: ids },
      limit: Number.MAX_SAFE_INTEGER,
      skipCount: true,
      client
    })
    return results
  }

  // getOne throws a 404 itself when no row matches.
  async getById (id) {
    return this.getOne(id, { whereCondition: 'fsid' })
  }

  // tenant (organisation) a program belongs to, lowercased
  async getProgramTenant (programId) {
    if (!programId) {
      throw new Error('programId required to get tenant')
    }
    const { rows } = await this.pgConnection.query(`
      select lower(org.name) as tenant
      from avocado.data_program dp
      left join avocado.data_organisation org on org.id = dp.owned_by
      where dp.fsid = $1
    `, [programId])
    return rows[0]
  }
}

module.exports = ProgramPgAdapter
